export default __webpack_public_path__ + "static/media/four_.fc922eb5.jpeg";